export default {
  /*viewmode: {
    label: 'Change viewmode',
    keys: ['1', '2', '3', '4'],
    default: false,
    desc: 'Changes between Laptop, Tablet and Phone viewmode'
  },*/
  viewmodeDesktop: {
    label: 'Change to desktop screen',
    keys: ['1'],
    default: false,
    desc: 'Sets editor to laptop'
  },
  viewmodeTablet: {
    label: 'Change to tablet screen',
    keys: ['2'],
    default: false,
    desc: 'Sets editor to tablet'
  },
  viewmodeMobile: {
    label: 'Change to mobile screen',
    keys: ['3'],
    default: false,
    desc: 'Sets editor to mobile device'
  },
  viewmodeStretch: {
    label: 'Stretch canvas to fill',
    keys: ['4'],
    default: false,
    desc: 'Sets editor to laptop desktop'
  },
};
